export default __webpack_public_path__ + "static/media/cuciReloadFaq1.a433345b.png";